import { createRouter, createWebHashHistory } from "vue-router";
import { useAuthStore } from '@/stores/auth'

import Home from "./views/home-page";
import Profile from "./views/profile-page";

import DockerAllContainers from "./views/docker-all-containers";
import DockerStats from "./views/docker-stats.vue";
import DockerContainersWithNetworks from "./views/docker-containers-with-networks.vue";
import DockerNetworksWithContainers from "./views/docker-networks-with-containers.vue";
import DockerNetworks from "./views/docker-networks.vue";

import HAProxyConfig from "./views/haproxy-config";
import HAProxyConfigValidate from "./views/haproxy-config-validate";
import HAProxyCerts from "./views/haproxy-certs";

import NginxSites from "./views/nginx-sites";

import CloudflareDNSrecords from "./views/cloudflare-dns-records.vue";
import CloudflareDnsRecordsAll from "./views/cloudflare-dns-records-all.vue";
import CloudflareDNSzones from "./views/cloudflare-dns-zones.vue";
import WordpressSiteSnaphots from "./views/wordpress-site-snapshots.vue";

import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";

const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Home
    },
    {
      path: "/profile",
      name: "profile",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Profile
    },
    {
      path: "/docker-all-containers",
      name: "All Containers",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: DockerAllContainers
    },
    {
      path: "/docker-stats",
      name: "Stats",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: DockerStats
    },
    {
      path: "/docker-containers-with-networks",
      name: "Containers with Networks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: DockerContainersWithNetworks
    },
    {
      path: "/docker-networks-with-containers",
      name: "Networks with Containers",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: DockerNetworksWithContainers
    },
    {
      path: "/docker-networks",
      name: "Networks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: DockerNetworks
    },
    {
      path: "/haproxy-config-validate",
      name: "haproxy-config-validate",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: HAProxyConfigValidate
    },
    {
      path: "/haproxy-config",
      name: "haproxy-config",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: HAProxyConfig
    },
    {
      path: "/haproxy-certs",
      name: "haproxy-cert",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: HAProxyCerts
    },
    {
      path: "/nginx-sites",
      name: "nginx-sites",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: NginxSites
    },
    {
      path: "/cloudflare-dns-records",
      name: "cloudflare-dns-records",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: CloudflareDNSrecords
    },
    {
      path: "/cloudflare-dns-records-all",
      name: "cloudflare-dns-records-all",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: CloudflareDnsRecordsAll
    },
    {
      path: "/cloudflare-dns-zones",
      name: "cloudflare-dns-zones",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: CloudflareDNSzones
    },
    {
      path: "/wordpress-site-snapshots",
      name: "wordpress-site-snapshots",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: WordpressSiteSnaphots
    },
    {
      path: "/login",
      name: "login",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign In"
      },
      component: () => import("./views/login-form.vue")
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home"
    }
  ],
  history: createWebHashHistory()
});

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    return next()
  }

  const store = useAuthStore()
  await store.init()

  if (!store.user) {
    return next({ name: 'login' })
  }

  next()
})

export default router
